import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const WalletIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 6C2 4.34315 3.34315 3 5 3H17C18.6569 3 20 4.34315 20 6V6.17071C21.1652 6.58254 22 7.69378 22 9V18C22 19.6569 20.6569 21 19 21H5C3.34315 21 2 19.6569 2 18V6ZM20 14V12H18C17.4477 12 17 12.4477 17 13C17 13.5523 17.4477 14 18 14H20ZM20 10H18C16.3431 10 15 11.3431 15 13C15 14.6569 16.3431 16 18 16H20V18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18V8H19C19.5523 8 20 8.44772 20 9V10ZM4 6H18C18 5.44772 17.5523 5 17 5H5C4.44772 5 4 5.44772 4 6Z'
        fill={color}
      />
    </svg>
  )
})
